import { IncomingTextsSVG, SendMessageSVG, WidgetSVG } from '@frontend/assets';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Text } from '@frontend/design-system';
import * as styles from './styles';

export const TextConnectDiagram = () => {
  const { t } = useTranslation('schedule');

  return (
    <div css={styles.textConnectDiagramContainer}>
      <div css={styles.textConnectDiagramCardContainer}>
        <WidgetSVG />
        <Text textAlign='center'>{t('Customers on your website submit a text via a widget or link')}</Text>
      </div>

      <Icon name='forward' color='light' css={styles.forwardIconStyle} />

      <div css={styles.textConnectDiagramCardContainer}>
        <SendMessageSVG />
        <Text textAlign='center'>{t('The text is sent to your Weave software')}</Text>
      </div>

      <Icon name='forward' color='light' css={styles.forwardIconStyle} />

      <div css={styles.textConnectDiagramCardContainer}>
        <IncomingTextsSVG />
        <Text textAlign='center'>{t('Weave identifies the incoming text as a new or existing customer')}</Text>
      </div>
    </div>
  );
};
